export const PRESS_LOGOS_MOBILE_LIMIT = 4;
